module.exports = "<div class=gmw-main-table ng-class=\"{\n    'desktop-only desktop-only--sm': desktopOnly,\n    'gmw-main-table--hover': hover,\n    'mobile-only mobile-only--sm': mobileOnly,\n    'gmw-main-table--small-padding': small,\n    'gmw-main-table--full-width': fullWidth\n  }\" ng-transclude> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/common/directives/main-table/main-table.html
// module id = 275
// module chunks = 0